<template>
    <el-dialog class="setPlayback" :close-on-click-modal="false" :close-on-press-escape="false" title="回放设置" width="688px" :visible.sync="dialogVisible">
        <div class="content">
            <div class="msgBox">
                <div class="title">当前回放</div>
                <div class="msgItem">
                    <div class="left">回放类型</div>
                    <div class="right">{{currentSet.ossurltype === 2 ? '自定义回放' : '直播回放'}}</div>
                </div>
                <div class="msgItem">
                    <div class="left">视频地址</div>
                    <div class="right">
                        <el-input disabled v-model="currentSet.ossurl"></el-input>
                    </div>
                </div>
            </div>
            <div class="setBox">
                <div class="title">修改回放</div>
                <el-form :model="ruleForm" :rules="rules" ref="ruleForm" label-width="80px">
                    <el-form-item label="回放类型" prop="ossurltype">
                        <el-radio-group v-model="ruleForm.ossurltype">
                            <el-radio :label="1">直播回放</el-radio>
                            <el-radio :label="2">自定义回放</el-radio>
                        </el-radio-group>
                    </el-form-item>
                    <el-form-item label="回放视频" prop="videoinfo" class="playbackVideo" v-if="ruleForm.ossurltype === 2">
                        <div class="uploadBox">
                            <el-button class="material" @click="openVideoScrollBox">素材库</el-button>
                            <uploadFile :uploadType="uploadVideoType" @setFile="setFile" :fileRule="fileRule"></uploadFile>
                            <span class="tips">* 仅支持MP4格式</span>
                        </div>
                        <div class="uploadTips" v-if="ruleForm.videoinfoObj">
                            <div class="left">{{ruleForm.videoinfoObj.fname}}</div>
                            <div class="right"><i @click="deleteVideoinfo" class="el-icon-close"></i></div>
                        </div>
                    </el-form-item>
                </el-form>
            </div>
            <scrollBox ref="videoScrollBox" :uploadType="uploadVideoType" @saveMaterialFile="setMaterialVideofile"></scrollBox>
        </div>
        <span slot="footer" class="dialog-footer">
            <el-button @click="dialogVisible = false">取 消</el-button>
            <el-button type="primary" @click="affirm">确 定</el-button>
        </span>
    </el-dialog>
</template>
<script>
import {getLiveOssSetting, updateLiveOssSetting} from 'api/api'
import UploadFile from 'base/upload/uploadFileResume'
import {mapGetters, mapActions} from 'vuex'
import ScrollBox from 'base/scrollBox/scrollBox'
export default {
    data() {
        const checkVideo = (rule, value, callback) => {
            if (this.ruleForm.ossurltype === 2) {
                if (!value) {
                    callback(new Error('请选择回放视频'))
                } else {
                    callback()
                }
            }
        }
        return {
            dialogVisible: false,
            uploadVideoType: {
                catecode: '103',
                datatype: 'VIDEO'
            },
            currentSet: {
                ossurl: '',
                ossurltype: ''
            },
            ruleForm: {
                ossurltype: 1,
                videoinfo: '',
                vsource: '',
                innerid: '',
                videoinfoObj: ''
            },
            rules: {
                ossurltype: [
                    {required: true, message: '请选择回放类型', trigger: 'blur'}
                ],
                videoinfo: [
                    {required: true, message: '请选择回放视频', trigger: 'blur'},
                    {validate: checkVideo, trigger: 'blur'}
                ]
            },
            fileRule: {
                btnName: '本地上传',
                cls: '',
                accept: 'video/mp4',
                size: 2 * 1024,
                width: '',
                height: ''
            }
        }
    },
    methods: {
        // 打开视频素材库选择框
        openVideoScrollBox() {
            this.$refs.videoScrollBox.openDialog()
        },
        open(innerid) {
            this.getLiveOssSetting(innerid)
            this.ruleForm = {
                ossurltype: 1,
                videoinfo: '',
                vsource: '',
                innerid: '',
                videoinfoObj: ''
            }
            this.ruleForm.innerid = innerid
        },
        getLiveOssSetting(innerid) {
            this.setLoading(true)
            getLiveOssSetting({
                data: {innerid},
                success: res => {
                    this.setLoading(false)
                    this.dialogVisible = true
                    this.currentSet = res.data
                    this.ruleForm.ossurltype = res.data.ossurltype
                    console.log(res)
                },
                error: res => {
                    this.setLoading(false)
                    this.$message.error(res.msg)
                }
            })
        },
        affirm() {
            this.$refs.ruleForm.validate((valid) => {
                if (valid) {
                    this.setLoading(true)
                    updateLiveOssSetting({
                        data: this.ruleForm,
                        success: res => {
                            this.setLoading(false)
                            this.$message.success('设置成功')
                            this.dialogVisible = false
                            console.log(res)
                        },
                        error: res => {
                            this.setLoading(false)
                            this.$message.error(res.msg)
                        }
                    })
                }
            })
        },
        setFile(file) {
            console.log(file)
            this.ruleForm.vsource = 1
            delete file.type
            this.ruleForm.videoinfo = JSON.stringify(file)
            this.ruleForm.videoinfoObj = file
            this.$refs.ruleForm.clearValidate()
            this.$message.success('上传成功')
        },
        // 设置素材库选择的视频信息
        setMaterialVideofile(file) {
            console.log(file)
            this.ruleForm.vsource = 2
            delete file.type
            this.ruleForm.videoinfo = JSON.stringify(file)
            this.ruleForm.videoinfoObj = file
            this.$refs.ruleForm.clearValidate()
            this.$message.success('选择成功')
        },
        deleteVideoinfo() {
            this.ruleForm.videoinfo = ''
            this.ruleForm.vsource = ''
            this.ruleForm.videoinfoObj = ''
        },
        ...mapActions([
            'setLoading'
        ])
    },
    components: {
        UploadFile,
        ScrollBox
    }
}
</script>
<style lang="scss">
    .setPlayback {
        .content {
            .msgBox {
                .title {
                    font-size: 16px;
                    font-weight: bold;
                    padding-left: 8px;
                    border-left: 2px solid #409EFF;
                    line-height: 16px;
                    margin-bottom: 16px;
                }
                .msgItem {
                    display: flex;
                    align-items: center;
                    margin-bottom: 22px;
                    padding-left: 10px;
                    .left {
                        font-size: 14px;
                        margin-right: 30px;
                    }
                    .right {
                        flex: 1;
                        .el-input {
                            width: 100%;
                        }
                    }
                }
            }
            .setBox {
                .title {
                    font-size: 16px;
                    font-weight: bold;
                    padding-left: 8px;
                    border-left: 2px solid #409EFF;
                    line-height: 16px;
                    margin-bottom: 20px;
                }
                .el-form {
                    padding-left: 8px;
                    .is-required {
                        .el-form-item__label::before {
                            display: none;
                        }
                        .el-form-item__label::after {
                            content: '*';
                            color: #F56C6C;
                            margin-left: 4px;
                        }
                    }
                    .el-form-item__content {
                        margin-left: 85px !important;
                    }
                    .playbackVideo {
                        .el-form-item__content {
                            .uploadBox {
                                display: flex;
                                align-items: center;
                                .el-button {
                                    margin-bottom: 0;
                                }
                                .material {
                                    margin-right: 20px;
                                }
                                .tips {
                                    margin-left: 12px;
                                    font-size: 12px;
                                    color: #C0C4CC;
                                }
                            }
                            .uploadTips {
                                display: flex;
                                align-items: center;
                                width: 300px;
                                justify-content: space-between;
                                padding: 0 10px;
                                cursor: pointer;
                                margin-top: 10px;
                                height: 20px;
                                &:hover {
                                    background:#f5f7fa;
                                }
                                .left {
                                    font-size: 14px;
                                    max-width: 250px;
                                    overflow: hidden;
                                    text-overflow: ellipsis;
                                    white-space: nowrap;
                                }
                            }
                        }
                    }
                }
            }
        }
    }
</style>
